import { createI18n } from "vue-i18n";
const _ = require("lodash");

const req = require.context("./i18n-services", true, /.json$/);
const messages = {
  en: {
    agreed: "Agreed",
    approved: "Approved",
    businessErrorsMessage: "Business errors message",
    warnings: "Warnings",
    infos: "Infos",
    fio: "First, last and second names",
    yes: "Yes",
    no: "No",
    id:"ID",
    rolesEmpty: "You have no one role",
    selectRoleForEnter: "Select role for enter",
    selectPeriod: "Select period",
    topics: "Topics",
    language: "Language",
    save: "Save",
    saveAll: "Save all",
    export_csv: "Export CSV",
    export_xlsx: "Export XLSX",
    up: "Up",
    down: "Down",
    changes: "Changes",
    fields: "Fields",
    field: "Field",
    fieldValue: "Field value",
    fieldName: "Field name",
    systemName: "System name",
    changeDateTime: "Change Date/Time",
    operation: "Operation",
    changeHistory: "Change History",
    history: "History",
    userProfile: "User profile",
    currentPassword: "Current password",
    currentRole: "Current Role",
    change: "Change",
    newPassword: "New password",
    activityPeriod: "Activity Period",
    activityPeriodF: "Activity period",
    addItemTxt: "Add",
    description: "Description",
    steps: "Steps",
    version: "Version",
    title: "Title",
    group: "Group",
    searchTxt: "Search",
    selectTxt: "Select",
    selectTxt2: "Choose",
    selectedFilterBy: "Filter selected by { name }",
    filterBy: "Filter by",
    editItemTxt: "Edit",
    createItemTxt: "Create",
    closeTxt: "Close",
    cancelTxt: "Cancel",
    selectAllTxt: "Select All",
    applyTxt: "Apply",
    confirmTxt: "Confirm",
    resetTxt: "Reset",
    choose: "Choose",
    clearFilterTxt: "Clear Filter",
    clearTxt: "Clear",
    customFilterTxt: "Custom Filter",
    newTxt: "New",
    newTasksTxt: "New",
    newTxtF: "New",
    newTxtT: "New",
    next: "Next",
    metaInfTxt: "Meta information",
    detailTxt: "Detail Text",
    allTxt: "All",
    recentlyTxt: "Recently added",
    recentlyViewed: "Recently viewed",
    deleted: "Deleted",
    unacted: "Unacted",
    overdue: "Overdue",
    delete: "Delete",
    deleting: "Deleting",
    record: "Record",
    deletingRole: "Deleting a role",
    deletingClaim: "Deleting a claim",
    questionDeleting: "Are you sure you want to delete a ",
    questionDeletingList: " from the list of recipients",
    open: "Open",
    created: "Created",
    createdByTxt: "Created by",
    updatedByTxt: "Updated by",
    createdAtTxt: "Created at",
    createdDate: "Creation date",
    lastUpdatedTxt: "Last updated",
    fromTxt: "from",
    toTxt: "to",
    settingsTxt: "Settings",
    systemSettings: "System settings",
    overview: "Overview",
    roles: "Roles",
    role: "Role",
    roleTitle: "Role name",
    roleLower: "role",
    localization: "Localization",
    firstName: "First name",
    secondName: "Second name",
    lastName: "Last name",
    email: "E-mail",
    node: "Node",
    nodes: "Nodes",
    holderName: "Holder name",
    holderEmail: "User email",
    loginType: "Login type",
    loginWith: "Login with",
    recipients: "Recipients",
    recipient: "Recipient",
    users: "Users",
    user: "User",
    userLower: "user",
    userCreateLower: "user",
    useCases: "Use cases",
    useCase: "Use case",
    useCaseLower: "use case",
    status: "Status",
    custom: "Custom",
    name: "Name",
    notifications: "Notifications",
    notification: "Notification",
    notificationLower: "notification",
    events: "Events",
    event: "Event",
    workflow: "Workflow",
    workflowLower: "workflow",
    mainInformation: "Main information",
    userInformation: "User name and other <br>contact information",
    additionalInformation: "Additional information",
    additionalInformationInformation:
      "Any other information that may<br>help to identify user",
    date: "Date",
    dateInformation: "Any other information that may<br>help to identify user",
    lastLoginDate: "Last login date",
    lastLoginDateInformation:
      "Last login date and time",
    lastLoginDateF: "Date and time",
    jobTitle: "Job Title",
    comments: "Comments",
    dateFormat: "Date format",
    dateTimeFormat: "Date time format",
    timeZone: "Time zone",
    timeFormat: "Time format",
    signIn: "Sign In",
    backToLogin: "Back to login",
    changePasswordB: "Change password",
    resetPasswordB: "Reset password",
    profile: "Profile",
    permissions: "Permissions",
    menuItems: "Menu items",
    menuItemL: "menu item",
    restrictions: "Restrictions",
    apiModels: "Api models",
    domainModels: "Domain models",
    itemsSelected: "Items selected",
    itemsSelectedAll: "Selected all",
    itemsSelectAll: "Total selected",
    itemsIncluded: "Selected",
    itemsExcluded: "Excluded",
    listIncluded: "Selected list",
    listExcluded: "Excluded list",
    roleProfile: "Role profile",
    identification: "Identification",
    identificationInformation: "Role name and other<br> contact information",
    usecaseName: "Use case name",
    usecaseTitle: "Use case title",
    usecaseDescription: "Usecase description",
    usecaseSampleDescription: "Usecase sample description",
    value: "Value",
    addValue: "Add value",
    added: "Added",
    excluded: "Excluded",
    noDataTitle: "Nothing to show yet",
    noDataTxt: "There are no records here yet",
    claims: "Claims",
    claim: "Claim",
    useCaseInformation: "Use case name and description",
    usecaseActivityPeriodInformation: "Pediod activity of use case",
    notificationType: "Notification type",
    ruleOptions: "Rule options",
    searchIn: "Search In",
    body: "Body",
    hasAttach: "Has attach",
    notificationMainInformationInformation:
      "Sample text block form here may<br>be different text block description",
    notificationActivityPeriodInformation: "Sample",
    notificationEventsInformation: "Sample",
    notificationNotificationTypeInformation: "Sample",
    notificationRuleOptionsInformation: "Sample",
    notificationRecipientsInformation: "Sample",
    expand: "Expand",
    collapse: "Collapse",
    step: "Step",
    workflowMainInformationInformation: "Workflow main information",
    workflowName: "Workflow name",
    workflowDescription: "Workflow description",
    activateWorkflow: "Activate",
    stepOptions: "Step options",
    stepNumber: "Step number",
    stepType: "Step type",
    stepName: "Step name",
    stepStatus: "Step status",
    condition: "Condition",
    onSuccess: "On Success",
    onSuccessF: "On success",
    onFailure: "On Failure",
    onFailureF: "On failure",
    parameters: "Parameters",
    parametersStep: "Parameters step",
    parameter: "Parameter",
    selectStepType: "Select step type",
    selectValue: "Select value",
    noSeletValue: "Not select",
    filter: "Filter",
    selectStep: "Select step",
    repeatPassword: "Repeat password",
    password: "Password",
    enterPassword: "Enter password",
    login: "Login",
    enterLogin: "Enter login",
    enterText: "Enter text",
    active: "Active",
    activeOne: "Active",
    activate: "Active",
    deactivate: "Deactive",
    paied: "Paied",
    draft: "Draft",
    new: "New",
    changed: "Changed",
    changedDate: "Changed date",
    changedDateFrom: "Changed from",
    changedDateTo: "Changed to",
    updated: "Updated",
    notUpdated: "Not updated",
    updatedDate: "Updated date",
    updatedDateFrom: "Updated from",
    updatedDateTo: "Updated to",
    plan: "Plan",
    fact: "Fact",
    done: "Done",
    inactive: "Inactive",
    code: "Code",
    workflowUniqueCode: "Workflow unique code",
    taskType: "Type",
    taskName: "Name",
    execution: "Execution",
    taskResult: "Task result",
    runResult: "Run result",
    taskLog: "Task log",
    downloadLog: "Download log",
    runAgain: "Run again",
    complete: "Complete",
    completeS: "Complete",
    error: "Error",
    errors: "Errors",
    systemTasks: "System tasks",
    backgroundTasks: "Background tasks",
    systemTaskLog: "Task log",
    import: "Import",
    loadingData: "Loading data",
    startedImport: "Started",
    finishedImport: "Finished",
    nonActive: "Not active",
    task: "Task",
    taskY: "Task",
    tasks: "Tasks",
    taskCreate: "Create task",
    taskEdit: "Edit task",
    nextExecution: "Next execution",
    lastExecution: "Last execution",
    startExecution: "Start execution",
    endExecution: "End execution",
    executionTime: "Execution time",
    trigger: "Trigger",
    triggers: "Triggers",
    addTrigger: "Add triggers",
    editTrigger: "Edit triggers",
    systemLog: "System log",
    pause: "Pause",
    run: "Run",
    repeat: "Repeat",
    every: "Every",
    everyDay: "Every day",
    everyWeek: "Every week",
    everyMonth: "Every month",
    time: "Time",
    onTheDays: "On the days",
    startRepeat: "Start repeat",
    endRepeat: "End repeat",
    taskDetails: "Task details",
    taskDetailsInfo: "Choose type task and write description.",
    repeatOptions: "Repeat options",
    scheduling: "Scheduling",
    lastStart: "Last start",
    nextStart: "Next start",
    once: "Once",
    second: "Second",
    minute: "Minute",
    hour: "Hour",
    day: "Day",
    week: "Week",
    month: "Month",
    sun: "Sun",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    path: "Path",
    icon: "Icon",
    order: "Order",
    parent: "Parent",
    parentField: "Parent field",
    add: "Add",
    uploadFileDragAndDropText: "Drag and drop files to here to upload",
    uploadFile: "Upload file",
    upload: "Upload",
    sourceFile: "Source file",
    importTemplate: "Import template",
    jobResult_ExportedCount: "rows exported",
    jobResult_ExportResultFile: "Export results",
    jobResult_SourceCount: "rows in source file",
    jobResult_ErrorsCount: "errors",
    jobResult_ImportedCount: "rows imported",
    jobResult_ErrorsCSV: "Download errors",
    jobResult_ShowErrors: "show errors",
    jobResult_UnknownFile: "Download file",
    jobResult_UnknownText: "",
    jobParameters_ImportFile: "Download import file",
    jobParameters_showModalParameters: "Show parameters",
    importSourceCount: "rows in source file",
    importErrorsCount: "import errors",
    importedCount: "rows imported",
    dashboard: "Dashboard",
    promo: "Promo",
    marketing: "Marketing",
    lock: "Lock",
    boxes: "Boxes",
    copy: "Copy",
    to: "To",
    BCC: "BCC",
    viewMore: "View more",
    showAll: "View All",
    authorIncludes: "Author (includes)",
    createDate: "Create date",
    editDate: "Edit date",
    startedAt: "Started at",
    finishedAt: "Finished at",
    userType: "User type",
    mainInfo: "User info",
    parentPosition: "Supervisor",
    position: "Position",
    legalAddress: "Legal address",
    mailAddress: "Mail address",
    phoneNumber: "Phone number",
    faxNumber: "Fax number",
    emailAddress: "Email address",
    MailingGroup: "Mailing group",
    User: "User",
    link: "Link",
    support: "Support",
    maxLengthErrorMessage: "Maximum length exceeded",
    minLengthErrorMessage: "Enter the phone completely",
    maxValueErrorMessage: "Max value: ",
    minValueErrorMessage: "Min value: ",
    requiredFieldErrorMessage: "Required field",
    featureInProgress: "The functionality will be added later",
    notValidPassword: "Not a valid password",
    information: "Information",
    type: "Type",
    info: "Info",
    recipientsTxt: "Recipient lists and types tasks",
    key: "Key",
    pictogram: "Pictogram",
    checkeds: "Checked",
    duration: "Duration",
    notValidPasswordLength: "Password shall be more or equal than 12 characters",
    notValidPasswordAlpth: "Password must contain an English letter",
    notValidPasswordAlpthUpper: "Password must contain an English capital letter",
    validatePasswordNumbers: "Password must contain a number",
    validatePasswordSymbols: "Password must contain a special character",
    validatePasswordUserId: "Password cannot contain an user Id",
    validatePasswordUserLogin: "Password cannot contain an user Login",
    validatePasswordUserEmail: "Password cannot contain an user Email",
    validatePasswordUserFirstName: "Password cannot contain an user First name",
    validatePasswordUserLastName: "Password cannot contain an user Last name",
    validatePasswordUserSecondName: "Password cannot contain an user Second name",
    validatePasswordSpace: "Password cannot contain a space character",
    validatePasswordMAAP: "Password cannot contain a MAAP keywords",
    validatePasswordEnglish: "Password can contain only English characters",
    notValidLogin: "Login can contain English letters, numbers, dot, underscore",
    notValidEmail: "Value is not a valid email address",
    requisites: "Requisites",
    tags: "Tags",
    validations: {
      localRequired: "Required field",
      localMaxLength: "Maximum length exceeded",
      localEmail: "Value is not a valid email address",
      localAgencyValidate: "Обязательное поле",
      localMinValue: "Minimum value is: {min}",
    },
    passwordChanged: "Password changed",
    address: "Address",
    // Адресная программа
    addressProgramImportType: "Upload type",
    addressProgramImportTypePlan: "Address program",
    addressProgramImportKPIPlan: "KPI plan",
    addressProgramImportKPIFact: "KPI fact",
    addressProgramImportBudgetFact: "Budget fact",
    addressProgramOutlet: "Outlet",
    addressProgramParameters: "Parameters",
    numberOfOutlets: "Number of outlets",
    totalOutlets: "Total outlets",
    budget: "Budget",
    publish: "Publish",
    reject: "Reject",
    accept: "Accept",
    comment: "Comment",
    send: "Send",
    addComment: "Add comment",
    isExpiredTxt: "Overdue",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    city: "City",
    area: "Area",
    cluster: "Cluster",
    rsm: "RSM",
    hsr: "HSR",
    tdm: "TDM",
    kae: "KAE",
    kadl: "KADL",
    outletType: "Outlet type",
    outletId: "Outlet ID",
    externalFormat: "External format",
    channel: "Channel",
    narka: "NA RKA",
    sipChannel: "SIP Channel",
    externalCode: "External code",
    territoryCluster: "Territory cluster",
    tariffZone: "Tariff zone",
    skyline: "Skyline",
    agency: "Agency",
    agencyList: "Agency list",
    rsmList: "RSM list",
    hsrList: "HSR list",
    coverage: "Coverage",
    includedInCoverage: "Included in coverage",
    inclusionInCoverage: "Inclusion in coverage",
    exclusionFromCoverage: "Exclusion from coverage",
    visitSum: "Visit sum",
    timingPerVisit: "Timing per visit",
    ratePerHour: "Rate per hour",
    osa: "OSA",
    pss: "PSS",
    isaOsa: "ISA-OSA",
    deltaIsaOsa: "Delta ISA-OSA",
    tacticalTask: "Tactical task",
    fteMerch: "FTE merch",
    totalSum: "Total sum",
    network: "Network",
    networkList: "Network list",
    kaeList: "KAE list",
    kadlList: "KADL list",
    kasList: "KAS list",
    merchList: "List of merchandisers",
    channelList: "List of channels",
    narkaList: "NA RKA List",
    geoClusterList: "List of geographic clusters",
    outletTypeList: "List of outlet types",
    externalFormatList: "List of external formats",
    sipChannelList: "List of SIP channels",
    routeCodeList: "List of route codes",
    networkCode: "Network code",
    marsPeriod: "Mars period",
    period: "Period",
    kpi: "KPI",
    openKpi: "Open KPI",
    businessKpi: "Business KPI",
    and: "and",
    planStatus: 'Plan',
    draftStatus: 'Draft',
    planFactStatus: 'Plan+fact',
    factStatus: 'Fact',
    order_created: 'Order created',
    order_published: 'Order published',
    order_approved: 'Order approved',
    order_completed: 'Order completed',
    order_factBudgetLoaded: 'Fact budget loaded',
    order_factBudgetApproved: 'Fact budget approved',
    period_opened: 'Opened',
    period_closed: 'Closed',
    periodClosingTitle: 'Closing period',
    new_period: 'New period',
    promptTxtPeriod: 'Do you really want to open a new period ',
    promptTxtClosePeriod: 'Do you really \nwant to close period ',
    storeCode: "Code",
    correctionRequest: "Correction request",
    correctionRequest2: "Request an adjustment",
    actions: "Actions",
    outlets: "Outlets",
    // Группировка
    networkName: 'Network name',
    storeType: 'Store type',
    geoCluster: 'Geo cluster',
    grouping: 'Grouping',
    userAgency: 'Agency',
    administrator: 'Administrator',
    agencyLinkInfo: "User type",
    agencyLinkInfoSub: "User type and agency",
    //Custom Filter
    customFilterTitle: 'Custom filter',
    ratePerHourPlan: 'Rate per hour plan',
    ratePerHourFact: 'Rate per hour fact',
    timingPerVisitPlan: 'Timing per visit plan',
    timingPerVisitFact: 'Timing per visit fact',
    fTEMerchPlan: 'FTE merch plan',
    fTEMerchFact: 'FTE merch fact',
    fTECountNorm: 'Нормативное количество FTE',
    frequencyPlan: 'Frequency plan',
    frequencyFact: 'Frequency plan',
    outletCount: 'Outlet count',
    oSAPlan: 'OSA plan',
    oSAFact: 'OSA fact',
    pSSPlan: 'PSS plan',
    pSSFact: 'PSS fact',
    tacticalTaskPlan: 'Tactical task plan',
    tacticalTaskFact: 'Tactical task fact',
    visitSum: 'Visit sum',
    visitSumPlan: 'Visit sum plan',
    oSASumPlan: 'OSA sum plan',
    oSASum: 'OSA sum',
    pSSSum: 'PSS sum',
    isaOsaSum: 'ISA-OSA sum',
    ISAOSAPlan: 'ISA-OSA (plan)',
    ISAOSAFact: 'ISA-OSA (fact)',
    deltaISAOSAPlan: 'Delta ISA-OSA (plan)',
    deltaISAOSAFact: 'Delta ISA-OSA (fact)',
    ISAOSABudgPlan: 'ISA-OSA budget plan',
    ISAOSABudgFact: 'ISA-OSA budget fact',
    tacticalTaskSum: 'Tactical task sum',
    tacticalTaskSumPlan: 'Tactical task sum plan',
    totalSumPlan: 'Total sum plan',
    visitSumFact: 'Visit sum fact',
    oSASumFact: 'OSA sum fact',
    pSSSumPlan: 'PSS sum plan',
    pSSSumFact: 'PSS sum fact',
    tacticalTaskSumFact: 'Tactical task sum fact',
    totalSumFact: 'Total sum fact',
    visitBudgetsPlan: 'Бюджет визиты (план)',
    visitBudgetsFact: 'Бюджет визиты (факт)',
    oSABudgPlan: 'Бюджет OSA (план)',
    oSABudgFact: 'Бюджет OSA (факт)',
    pSSBudgPlan: 'Бюджет PSS (план)',
    pSSBudgFact: 'Бюджет PSS (факт)',
    tacticalTaskBudgPlan: 'Бюджет Такт. задача (план)',
    tacticalTaskBudgFact: 'Бюджет Такт. задача (факт)',
    budgetSumPlan: 'Бюджет всего (план)',
    budgetSumFact: 'Бюджет всего (факт)',
    completion: 'Completion',
    exitFromPageConfirmTxt: 'Confirmation of leaving the page',
    unsavedChangesTxt: 'You didn\'t save the changes you made.',
    exitFromPageTxt: 'Do you really want to leave the page?',
    emptyFilterMessage: "No results found",
    noData: "No Data",
    accepted: "Accepted",
    rejected: "Rejected",
    partiallyAccepted: "Partially Accepted",
    download: "Download",
    dateFormatDDMMYYYY: "DD.MM.YYYY",
    dateFormatMMDDYYYY: "MM.DD.YYYY",
    dateFormatYYYYMMDD: "YYYY.MM.DD",
    timeFormat12: "12 hour",
    timeFormat24: "24 hour",
    sideBarThemeTxt: "Theme",
    sideBarLanguageTxt: "Language",
    sideBarLogoutTxt: "Log out",
    sideBarStorageTxt: "Clear cache",
    select: "Select",
    unreaded: "Unreaded",
    or: "or",
    loading: "Loading",
    returnToLoginPage: "Return to login page",
    historyMain: "Main",
    createdOperation: "Created",
    updatedOperation: "Updated",
    deletedOperation: "Deleted",
    theme: "Theme",
    logout: "Log out",
    taskStatus_new: 'New',
    taskStatus_complete: 'Complete',
    taskStatus_error: 'Error',
    taskStatus_accepted: 'In progress',
    taskStatus_partialcomplete: 'Partial complete',
    showErrorDetails: "Show details",
    questClearFilters: "Selected entries will be reset",
    bodyClearFilters: "When this option is applied, the previous selected entries will be reset",
    txtResetFilters: "Reset all filters",
    searchOnOutletId: "Search by point code",
    txtChipsList: "Open full list",
    blockChipsTitle: "Maximum number of entries exceeded",
    blockChipsBody: "The maximum number of records to insert cannot exceed 999. Reduce the number of records and try again",
    alertChangeTimezone: "To apply the parameters, you will log out of the system",
    signOut: "Sign Out",
    default: "Default",
    alertRoleHasChangedTitle: "Role change detected",
    alertRoleHasChangedTxt: "Access to the operation is denied. To continue working in the system, you will be redirected to the main page.",
    serviceTxt: "Service",
    claimTxt: "Claim",
    dateMustBeLessThanEnd: "The start date must be less than the end date",
    dateMustBeGreaterThanStart: "The end date must be greater than the start date",
    selectDate: "Select a date",
    deletingConfirmation: "Confirmation of deletion",
    deleteBaseType: "Are you sure want to delete<br>the base type <span style=\"color:#2196f3\">{name}</span>?",
  },
  ru: {
    agreed: "Согласовано",
    approved: "Утверждено",
    businessErrorsMessage: "Сообщение об ошибках",
    warnings: "Предупреждения",
    infos: "Информация",
    fio: "ФИО",
    yes: "Да",
    no: "Нет",
    id: "ID",
    rolesEmpty: "У вас нет ни одной роли",
    selectRoleForEnter: "Выбрать роль для входа",
    selectPeriod: "Выбрать период",
    topics: "Разделы",
    editDate: "Дата редактирования",
    version: "Версия",
    createDate: "Дата создания",
    authorIncludes: "Автор (вхождения)",
    viewMore: "Показать больше",
    showAll: "Показать всё",
    copy: "Копия",
    to: "Кому",
    BCC: "Скрытые",
    boxes: "Блоки",
    lock: "Закрыто",
    marketing: "Маркетинг",
    promo: "Промо",
    dashboard: "Дашборд",
    language: "Язык",
    save: "Сохранить",
    saveAll: "Сохранить всё",
    export_csv: "Экспорт CSV",
    export_xlsx: "Экспорт XLSX",
    up: "Вверх",
    down: "Вниз",
    changes: "Изменения",
    fields: "Поля",
    field: "Поле",
    fieldValue: "Значение поля",
    fieldName: "Название поля",
    systemName: "Системное название",
    changeDateTime: "Дата/время изменения",
    operation: "Операция",
    changeHistory: "История изменений",
    history: "История",
    userProfile: "Профиль пользователя",
    currentPassword: "Текущий пароль",
    currentRole: "Текущая роль",
    change: "Изменить",
    newPassword: "Новый пароль",
    activityPeriod: "Период Активности",
    activityPeriodF: "Период активности",
    addItemTxt: "Добавить",
    description: "Описание",
    steps: "Шаги",
    title: "Заголовок",
    group: "Группа",
    searchTxt: "Поиск",
    selectTxt: "Выбор",
    filterBy: "Фильтры:",
    editItemTxt: "Редактировать",
    createItemTxt: "Создать",
    closeTxt: "Закрыть",
    cancelTxt: "Отменить",
    selectAllTxt: "Выбрать всё",
    selectTxt2: "Выбрать",
    selectedFilterBy: "Выбран фильтр по { name }",
    applyTxt: "Применить",
    confirmTxt: "Подтвердить",
    resetTxt: "Сбросить",
    choose: "Выбрать",
    clearFilterTxt: "Очистить фильтр",
    clearTxt: "Очистить",
    customFilterTxt: "Общий фильтр",
    newTxt: "Новый",
    newTxtF: "Новая",
    newTxtT: "Новое",
    next: "Далее",
    metaInfTxt: "Мета информация",
    detailTxt: "Подробно",
    allTxt: "Все",
    active: "Активные",
    activeOne: "Активный",
    activate: "Активировать",
    deactivate: "Деактивированные",
    paied: "Оплаченные",
    draft: "Черновики",
    new: "Новый",
    changed: "Изменено",
    changedDate: "Дата изменения",
    changedDateFrom: "Изменено с",
    changedDateTo: "Изменено по",
    updated: "Обновлено",
    notUpdated: "Не обновлено",
    updatedDate: "Дата обновления",
    updatedDateFrom: "Обновлено с",
    updatedDateTo: "Обновлено по",
    plan: "План",
    fact: "Факт",
    done: "Исполнено",
    inactive: "Неактивные",
    recentlyTxt: "Недавние",
    recentlyViewed: "Недавно просмотренные",
    deleted: "Удалённые",
    unacted: "Невыполненные",
    overdue: "Просроченные",
    delete: "Удалить",
    deleting: "Удаление",
    record: "Запись",
    deletingRole: "Удаление роли",
    deletingClaim: "Удаление права",
    questionDeleting: "Вы действительно хотите удалить ",
    questionDeletingList: " из списка получателей",
    open: "Открыть",
    created: "Создано",
    createdByTxt: "Кем создано",
    updatedByTxt: "Кем обновлено",
    createdAtTxt: "Когда создано",
    createdDate: "Дата создания",
    lastUpdatedTxt: "Обновлено",
    fromTxt: "от",
    toTxt: "до",
    settingsTxt: "Настройки",
    systemSettings: "Системные настройки",
    overview: "Обзор",
    roles: "Роли",
    role: "Роль",
    roleTitle: "Название роли",
    localization: "Локализация",
    roleLower: "роль",
    firstName: "Имя",
    secondName: "Отчество",
    lastName: "Фамилия",
    email: "Почта",
    node: "Узел",
    nodes: "Узлы",
    holderName: "Имя пользователя",
    holderEmail: "Email пользователя",
    loginType: "Тип логина",
    recipients: "Получатели",
    recipient: "Получатель",
    users: "Пользователи",
    user: "Пользователь",
    userLower: "пользователь",
    userCreateLower: "пользователя",
    useCases: "Сценарии использования",
    useCase: "Сценарий использования",
    useCaseLower: "cценарий использования",
    status: "Статус",
    custom: "Общий",
    name: "Имя",
    notifications: "Уведомления",
    notification: "Уведомление",
    notificationLower: "уведомление",
    events: "События",
    event: "Событие",
    workflow: "Рабочий процесс",
    workflowLower: "рабочий процесс",
    mainInformation: "Основная информация",
    userInformation: "Имя пользователя и другая <br>контактная информация",
    additionalInformation: "Дополнительная информация",
    additionalInformationInformation:
      "Любая другая информация, <br>которая может помочь идентифицировать пользователя",
    date: "Дата",
    dateInformation:
      "Любая другая информация, <br>которая может помочь идентифицировать пользователя",
    lastLoginDate: "Дата последнего входа в систему",
    lastLoginDateInformation:
      "Дата и время последнего входа в систему",
    lastLoginDateF: "Дата и время",
    jobTitle: "Должность",
    comments: "Комментарии",
    dateFormat: "Формат даты",
    dateTimeFormat: "Формат даты и времени",
    timeZone: "Часовой пояс",
    timeFormat: "Формат времени",
    backToLogin: "Вернуться к выбору",
    loginWith: "Войти с помощью",
    signIn: "Войти",
    changePasswordB: "Сменить пароль",
    resetPasswordB: "Сбросить пароль",
    profile: "Профиль",
    permissions: "Разрешения",
    menuItems: "Пункты меню",
    menuItemL: "пункт меню",
    restrictions: "Ограничения",
    apiModels: "Модели Api",
    domainModels: "Доменные модели",
    itemsSelected: "Выбрано",
    itemsSelectedAll: "Выбрано все",
    itemsSelectAll: "Выбрано всего",
    itemsIncluded: "Выбрано",
    itemsExcluded: "Исключено",
    listIncluded: "Список выбранных",
    listExcluded: "Список исключенных",
    roleProfile: "Профиль роли",
    identification: "Идентификация",
    identificationInformation: "Имя роли и другая контактная информация",
    usecaseName: "Название cценария использования",
    usecaseTitle: "Заголовок cценария использования",
    usecaseDescription: "Описание cценария использования",
    usecaseSampleDescription: "Простое описание cценария использования",
    value: "Значение",
    addValue: "Добавить значение",
    added: "Добавлены",
    excluded: "Исключены",
    noDataTitle: "Пока нечего показывать",
    noDataTxt: "Здесь пока нет никаких записей",
    claims: "Права",
    claim: "Права",
    useCaseInformation: "Название и описание сценария использования",
    usecaseActivityPeriodInformation: "Период действия сценария использования",
    notificationType: "Тип уведомления",
    ruleOptions: "Параметры правил",
    searchIn: "Искать В",
    body: "Тело",
    hasAttach: "Имеет прикрепление",
    notificationMainInformationInformation:
      "Пример формы текстового блока здесь может отличаться описанием текстового блока",
    notificationActivityPeriodInformation:
      "Пример формы текстового блока здесь может отличаться описанием текстового блока",
    notificationEventsInformation:
      "Пример формы текстового блока здесь может отличаться описанием текстового блока",
    notificationNotificationTypeInformation:
      "Пример формы текстового блока здесь может отличаться описанием текстового блока",
    notificationRuleOptionsInformation:
      "Пример формы текстового блока здесь может отличаться описанием текстового блока",
    notificationRecipientsInformation:
      "Пример формы текстового блока здесь может отличаться описанием текстового блока",
    expand: "Развернуть",
    collapse: "Свернуть",
    step: "Шаг",
    workflowMainInformationInformation:
      "Основная информация о рабочем процессе",
    workflowName: "Имя рабочего процесса",
    workflowDescription: "Описание рабочего процесса",
    activateWorkflow: "Активировать",
    stepOptions: "Параметры шага",
    stepNumber: "Номер шага",
    stepType: "Тип шага",
    stepName: "Имя шага",
    stepStatus: "Статус шага",
    condition: "Состояние",
    onSuccess: "При Успехе",
    onSuccessF: "При успехе",
    onFailure: "При Неудаче",
    onFailureF: "При неудаче",
    parameters: "Параметры",
    parametersStep: "Параметры шага",
    parameter: "Параметр",
    selectStepType: "Выберите тип шага",
    selectValue: "Выберите значение",
    noSeletValue: "Не выбрано",
    filter: "Фильтр",
    selectStep: "Выберите шаг",
    repeatPassword: "Повторите Пароль",
    password: "Пароль",
    enterPassword: "Введите пароль",
    login: "Логин",
    enterLogin: "Введите логин",
    enterText: "Введите текст",
    code: "Код",
    workflowUniqueCode: "Уникальный код рабочего процесса",
    taskType: "Тип",
    taskName: "Название",
    execution: "Исполнение",
    taskResult: "Результат задачи",
    runResult: "Результат выполнения",
    taskLog: "Журнал задач",
    downloadLog: "Скачать лог",
    runAgain: "Повтор",
    complete: "Завершенный",
    completeS: "Завершенныe",
    error: "Ошибка",
    errors: "Ошибки",
    systemTasks: "Системные задачи",
    backgroundTasks: "Фоновые задачи",
    systemTaskLog: "Лог задач",
    import: "Импорт",
    loadingData: "Загрузка данных",
    startedImport: "Запущена",
    finishedImport: "Завершена",
    nonActive: "Не Активные",
    task: "Задача",
    taskY: "Задачу",
    tasks: "Задачи",
    taskCreate: "Создать задачу",
    taskEdit: "Редактировать задачу",
    nextExecution: "Следующий запуск",
    lastExecution: "Последний запуск",
    startExecution: "Начало выполнения",
    endExecution: "Конец выполнения",
    executionTime: "Время выполнения",
    trigger: "Триггер",
    triggers: "Триггеры",
    addTrigger: "Создать триггер",
    editTrigger: "Редактировать триггер",
    systemLog: "Системные задачи",
    pause: "Пауза",
    run: "Запуск",
    repeat: "Повторять",
    every: "Каждый",
    everyDay: "Каждый день",
    everyWeek: "Каждую неделю",
    everyMonth: "Каждый месяц",
    time: "Время",
    onTheDays: "В дни",
    startRepeat: "Начало повторения",
    endRepeat: "Окончание повторений",
    taskDetails: "Детали задачи",
    taskDetailsInfo: "Выберите тип задачи и напишите описание.",
    repeatOptions: "Настройки повторения",
    scheduling: "Планирование",
    lastStart: "Последний старт",
    nextStart: "Следующий старт",
    once: "Одиночное",
    second: "Секунда",
    minute: "Минута",
    hour: "Час",
    day: "День",
    week: "Неделя",
    month: "Месяц",
    sun: "Вск",
    mon: "Пн",
    tue: "Вт",
    wed: "Ср",
    thu: "Чт",
    fri: "Пт",
    sat: "Сб",
    path: "Путь",
    icon: "Изображение",
    order: "Порядок",
    parent: "Родитель",
    parentField: "Родительское поле",
    add: "Добавить",
    uploadFileDragAndDropText: "Перетащите файл в данную область для загрузки",
    uploadFile: "Загрузить файл",
    upload: "Загрузить",
    sourceFile: "Исходный файл",
    importTemplate: "Шаблон импорта",
    jobResult_ExportedCount: "строк успешно экспортировано",
    jobResult_ExportResultFile: "Результаты экспорта",
    jobResult_SourceCount: "строк в исходном файле",
    jobResult_ErrorsCount: "ошибок",
    jobResult_ImportedCount: "строк импортированно",
    jobResult_ErrorsCSV: "Cкачать файл с ошибками",
    jobResult_UnknownFile: "Скачать файл",
    jobResult_UnknownText: "",
    jobParameters_ImportFile: "Cкачать файл импорта",
    jobResult_ShowErrors: "Открыть ошибки",
    jobParameters_showModalParameters: "Открыть параметры",
    importSourceCount: "строк в загружаемом файле",
    importErrorsCount: "ошибок импорта",
    importedCount: "строк успешно импортированно",
    startedAt: "Начало",
    finishedAt: "Окончание",
    userType: "Тип пользователя",
    mainInfo: "Основная информация",
    parentPosition: "Руководитель",
    position: "Позиция",
    legalAddress: "Юридический адрес",
    mailAddress: "Почтовый адрес",
    phoneNumber: "Телефон",
    faxNumber: "Факс",
    emailAddress: "Электронный адрес",
    MailingGroup: "Группа рассылки",
    User: "Пользователь",
    link: "Ссылка",
    support: "Поддержка",
    maxLengthErrorMessage: "Превышена максимальная длина",
    minLengthErrorMessage: "Введите телефон полностью",
    maxValueErrorMessage: "Максимальное значение: ",
    minValueErrorMessage: "Минимальное значение: ",
    requiredFieldErrorMessage: "Обязательное поле",
    featureInProgress: "Функционал добавится позднее",
    notValidPassword: "Некорректный пароль",
    information: "Информация",
    type: "Тип",
    info: "Инфо",
    recipientsTxt: "Списки и типы получателей задачи",
    key: "Ключ",
    pictogram: "Пиктограмма",
    checkeds: "Помеченные",
    duration: "Длительность, дней",
    notValidPasswordLength: "Пароль должен быть больше 12 символов",
    notValidPasswordAlpth: "Пароль должен содержать английскую прописную букву",
    notValidPasswordAlpthUpper: "Пароль должен содержать английскую заглавную букву",
    validatePasswordNumbers: "Пароль должен содержать цифру",
    validatePasswordSymbols: "Пароль должен содержать специальный символ",
    validatePasswordUserId: "Пароль не должен содержать Id пользователя",
    validatePasswordUserLogin: "Пароль не должен содержать логин пользователя",
    validatePasswordUserEmail: "Пароль не должен содержать почту пользователя",
    validatePasswordUserFirstName: "Пароль не должен содержать имя пользователя",
    validatePasswordUserLastName: "Пароль не должен содержать фамилию пользователя",
    validatePasswordUserSecondName: "Пароль не должен содержать отчество пользователя",
    validatePasswordSpace: "Пароль не должен содержать пробел",
    validatePasswordMAAP: "Пароль не должен содержать ключевые слова проекта",
    validatePasswordEnglish: "Пароль должен содержать только английские буквы",
    notValidLogin: "Логин может содержать английские буквы, цифры, точку и нижнее подчеркивание",
    notValidEmail: "Некорректный электронный адрес",
    company: "Компания",
    requisites: "Реквизиты",
    tags: "Теги",
    validations: {
      localRequired: "Обязательное поле",
      localMaxLength: "Превышена максимальная длина",
      localEmail: "Некорректный электронный адрес",
      localAgencyValidate: "Обязательное поле",
      localMinValue: "Минимальное значение: {min}",
    },
    passwordChanged: "Пароль изменен",
    address: "Адрес",
    // Адресная программа
    addressProgramImportType: "Тип загрузки",
    addressProgramImportTypePlan: "Адресная программа",
    addressProgramImportKPIPlan: "KPI план",
    addressProgramImportKPIFact: "KPI факт",
    addressProgramImportBudgetFact: "Бюджет факт",
    addressProgramOutlet: "Торговая точка",
    addressProgramParameters: "Параметры",
    numberOfOutlets: "Кол-во ТТ",
    totalOutlets: "Всего ТТ",
    budget: "Бюджет",
    publish: "Опубликовать",
    reject: "Отменить",
    accept: "Подтвердить",
    comment: "Комментарий",
    send: "Отправить",
    addComment: "Добавить комментарий",
    isExpiredTxt: "Просроченные",
    daily: "Ежедневно",
    weekly: "Еженедельно",
    monthly: "Ежемесячно",
    city: "Город",
    area: "Область",
    cluster: "Кластер",
    rsm: "RSM",
    hsr: "HSR",
    tdm: "TDM",
    kae: "KAE",
    kadl: "KADL",
    outletType: "Тип точки",
    outletId: "ID точки",
    externalFormat: "Внешний формат",
    channel: "Канал",
    narka: "NA RKA",
    sipChannel: "SIP Канал",
    externalCode: "Внешний код",
    territoryCluster: "Терр. кластер",
    tariffZone: "Тарифная зона",
    skyline: "Skyline",
    agency: "Агентство",
    agencyList: "Список агентств",
    rsmList: "Список RSM",
    hsrList: "Список HSR",
    coverage: "Покрытие",
    includedInCoverage: "Включено в покрытие",
    inclusionInCoverage: "Включение в покрытие",
    exclusionFromCoverage: "Исключение из покрытия",
    visitSum: "Кол-во визитов",
    timingPerVisit: "Тайминг на визит",
    ratePerHour: "Ставка нормочаса",
    osa: "OSA",
    pss: "PSS",
    isaOsa: "ISA-OSA",
    deltaIsaOsa: "Дельта ISA-OSA",
    tacticalTask: "Такт. задача",
    fteMerch: "FTE Мерчендайзера",
    totalSum: "Бюджет всего",
    network: "Сеть",
    networkList: "Список сетей",
    kaeList: "Список KAE",
    kadlList: "Список KADL",
    kasList: "Список KAS",
    merchList: "Список мерчендайзеров",
    channelList: "Список каналов",
    narkaList: "Список NA RKA",
    geoClusterList: "Список географических кластеров",
    outletTypeList: "Список типов точек",
    externalFormatList: "Список внешних форматов",
    sipChannelList: "Список SIP каналов",
    routeCodeList: "Список кодов маршрутов",
    networkCode: "Код сети",
    marsPeriod: "Период",
    period: "Период",
    kpi: "KPI",
    openKpi: "KPI по покрытию",
    businessKpi: "Бизнес KPI",
    and: "и",
    storeCode: "Код точки",
    correctionRequest: "Запрос на корректировку",
    correctionRequest2: "Запросить корректировку",
    actions: "Действия",
    outlets: "Торговые точки",
    // Статусы
    planStatus: 'План',
    draftStatus: 'Черновик',
    planFactStatus: 'План+факт',
    factStatus: 'Факт',
    order_created: 'Заказ создан',
    order_published: 'Заказ опубликован',
    order_approved: 'Заказ утверждён',
    order_completed: 'Заказ исполнен',
    order_factBudgetLoaded: 'Факт. бюджет загружен',
    order_factBudgetApproved: 'Факт. бюджет подтвержден',
    period_opened: 'Открыт',
    period_closed: 'Закрыт',
    periodClosingTitle: 'Закрытие периода',
    new_period: 'Новый период',
    taskStatus_new: 'Новая',
    taskStatus_complete: 'Завершена',
    taskStatus_error: 'Ошибка',
    taskStatus_accepted: 'В процессе',
    taskStatus_partialcomplete: 'Частично завершена',
    promptTxtPeriod: 'Вы действительно хотите открыть новый период ',
    promptTxtClosePeriod: 'Вы действительно хотите\n закрыть период ',
    // Группировка
    networkName: 'Название сети',
    storeType: 'Тип точки',
    geoCluster: 'Географический кластер',
    geoClusterShort: 'Геогр. кластер',
    grouping: 'Группировка',
    userAgency: 'Агентство',
    administrator: 'Администратор',
    agencyLinkInfo: "Тип пользователя",
    agencyLinkInfoSub: "Тип пользователя и агентство",
    //Общий фильтр
    customFilterTitle: 'Общий фильтр',
    ratePerHourPlan: 'Часовая ставка план',
    ratePerHourFact: 'Часовая ставка факт',
    timingPerVisitPlan: 'Тайминг на визит план',
    timingPerVisitFact: 'Тайминг на визит факт',
    timingPerVisitNorm: 'Нормативный тайминг на визит',
    fTEMerchPlan: 'FTE Мерчендайзера план',
    fTEMerchFact: 'FTE Мерчендайзера факт',
    fTECountNorm: 'Нормативное количество FTE',
    frequencyPlan: 'Частота план',
    frequencyFact: 'Частота факт',
    outletCount: 'Количество точек',
    oSAPlan: 'OSA (план)',
    oSAFact: 'OSA (факт)',
    pSSPlan: 'PSS (план)',
    pSSFact: 'PSS (факт)',
    tacticalTaskPlan: 'Тактическая задача (план)',
    tacticalTaskFact: 'Тактическая задача (факт)',
    visitSum: 'Количество визитов',
    visitSumPlan: 'Количество визитов (план)',
    visitSumFact: 'Количество визитов (факт)',
    oSASumPlan: 'Сумма OSA план',
    oSASum: 'Сумма OSA',
    pSSSum: 'Сумма PSS',
    isaOsaSum: 'Сумма ISA-OSA',
    ISAOSAPlan: 'ISA-OSA (план)',
    ISAOSAFact: 'ISA-OSA (факт)',
    deltaISAOSAPlan: 'Дельта ISA-OSA (план)',
    deltaISAOSAFact: 'Дельта ISA-OSA (факт)',
    ISAOSABudgPlan: 'Бюджет Дельта ISA-OSA (план)',
    ISAOSABudgFact: 'Бюджет Дельта ISA-OSA (факт)',
    tacticalTaskSum: 'Сумма тактических задач',
    tacticalTaskSumPlan: 'Сумма тактических задач план',
    totalSumPlan: 'Сумма всего план',
    totalSumFact: 'Сумма всего факт',
    oSASumFact: 'Сумма OSA факт',
    pSSSumPlan: 'Сумма PSS план',
    pSSSumFact: 'Сумма PSS факт',
    tacticalTaskSumFact: 'Сумма тактических задач факт',
    visitBudgetsPlan: 'Бюджет визиты (план)',
    visitBudgetsFact: 'Бюджет визиты (факт)',
    oSABudgPlan: 'Бюджет OSA (план)',
    oSABudgFact: 'Бюджет OSA (факт)',
    pSSBudgPlan: 'Бюджет PSS (план)',
    pSSBudgFact: 'Бюджет PSS (факт)',
    tacticalTaskBudgPlan: 'Бюджет Такт. задача (план)',
    tacticalTaskBudgFact: 'Бюджет Такт. задача (факт)',
    budgetSumPlan: 'Бюджет всего (план)',
    budgetSumFact: 'Бюджет всего (факт)',
    completion: 'Выполнение',
    exitFromPageConfirmTxt: 'Подтверждение ухода со страницы',
    unsavedChangesTxt: 'Вы не сохранили внесенные изменения.',
    exitFromPageTxt: 'Вы действительно хотите покинуть страницу?',
    emptyFilterMessage: "Результатов не найдено",
    noData: "Нет данных",
    accepted: "Подтверждено",
    rejected: "Отклонено",
    partiallyAccepted: "Частично подтверждено",
    download: "Скачать",
    dateFormatDDMMYYYY: "ДД.ММ.ГГГГ",
    dateFormatMMDDYYYY: "ММ.ДД.ГГГГ",
    dateFormatYYYYMMDD: "ГГГГ.ММ.ДД",
    timeFormat12: "12-часовой",
    timeFormat24: "24-часовой",
    sideBarThemeTxt: "Тема",
    sideBarLanguageTxt: "Язык",
    sideBarLogoutTxt: "Выйти",
    sideBarStorageTxt: "Очистить кеш",
    select: "Выбрать",
    unreaded: "Непрочитанные",
    or: "или",
    loading: "Загрузка",
    returnToLoginPage: "Вернуться на страницу входа",
    historyMain: "Главное",
    createdOperation: "Создание",
    updatedOperation: "Редактирование",
    deletedOperation: "Удаление",
    theme: "Тема",
    logout: "Выйти",
    newTasksTxt: "Новые",
    showErrorDetails: "Показать ошибки",
    questClearFilters: "Выбранные записи будут сброшены",
    bodyClearFilters: "При применении данной опции предыдущие выбранные записи будут сброшены",
    txtResetFilters: "Сброс всех фильтров",
    searchOnOutletId: "Поиск по коду точки",
    txtChipsList: "Открыть полный список",
    blockChipsTitle: "Превышено максимальное количество записей",
    blockChipsBody: "Максимальное количество записей для вставки не может превышать 999. Уменьшите количество записей и повторите попытку снова",
    alertChangeTimezone: "Для применения параметров будет выполнен выход из системы",
    signOut: "Выход из системы",
    default: "По умолчанию",
    alertRoleHasChangedTitle: "Обнаружено изменение роли",
    alertRoleHasChangedTxt: " Доступ к операции запрещён. Для продолжения работы в системе вы будете перенаправлены на главную страницу.",
    serviceTxt: "Сервис",
    claimTxt: "Клейм",
    dateMustBeLessThanEnd: "Дата начала должна быть меньше даты окончания",
    dateMustBeGreaterThanStart: "Дата окончания должна быть больше даты начала",
    selectDate: "Выберите дату",
    deletingConfirmation: "Подтверждение удаления",
    deleteBaseType: "Вы действительно хотите удалить<br>тип <span style=\"color:#2196f3\">{name}</span>?",
  },
};

req
  .keys()
  .map(req)
  .forEach((module) => {
    _.merge(messages, module);
  });

const i18n = createI18n({
  locale: "ru",
  legacy: false,
  globalInjection: true,
  messages,
});
export default i18n;
